<template>
<svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.5 7.24999C0.5 4.29126 0.5 2.8119 1.31716 1.81618C1.46676 1.6339 1.6339 1.46676 1.81618 1.31716C2.8119 0.5 4.29126 0.5 7.24999 0.5C10.2087 0.5 11.6881 0.5 12.6838 1.31716C12.8661 1.46676 13.0332 1.6339 13.1828 1.81618C14 2.8119 14 4.29126 14 7.24999V8.14999C14 11.1087 14 12.5881 13.1828 13.5838C13.0332 13.7661 12.8661 13.9332 12.6838 14.0828C11.6881 14.9 10.2087 14.9 7.24999 14.9C4.29126 14.9 2.8119 14.9 1.81618 14.0828C1.6339 13.9332 1.46676 13.7661 1.31716 13.5838C0.5 12.5881 0.5 11.1087 0.5 8.14999V7.24999Z" stroke="white"/>
<path d="M14 5.45007L14.5926 5.15381C16.3438 4.27816 17.2195 3.84034 17.8597 4.23604C18.5 4.63175 18.5 5.61075 18.5 7.56876V7.83138C18.5 9.78942 18.5 10.7683 17.8597 11.1641C17.2195 11.5598 16.3438 11.122 14.5926 10.2463L14 9.95007V5.45007Z" stroke="white"/>
</svg>
</template>

<script>
export default {
  name: 'IconCamera'
}
</script>
